import { Type } from '@sinclair/typebox';
import { createPathGuidParameter } from '../../routes/createPathParameter';
import { makeStringEnum } from '../../utils/typeboxHelpers';
import { assetTableSchema } from '../asset/assetTableSchema';

const optionalScoreSchema = Type.Optional(makeStringEnum(['NVT', 'OK', 'A', 'B', 'C', 'D', 'E', 'F']));

export const amsterdamOverspanningenPaths = {
    '/api/surveys/{surveyId}/elements/{elementId}/inspectionStandardData/amsterdamOverspanningen/inspectieOverspanningen`': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('elementId')],
        get: {
            operationId: 'aoInspectieOverspanningenControllers.getElement',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Any(),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/units/{unitId}/inspectionStandardData/amsterdamOverspanningen/inspectieOverspanningen': {
        parameters: [createPathGuidParameter('surveyId'), createPathGuidParameter('unitId')],
        get: {
            operationId: 'aoInspectieOverspanningenControllers.getUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Any(),
                        },
                    },
                },
            },
        },
        post: {
            operationId: 'aoInspectieOverspanningenControllers.updateUnit',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Any(),
                        },
                    },
                },
            },
            requestBody: {
                content: {
                    'application/json': {
                        schema: Type.Any(),
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/elements/amsterdamOverspanningen/inspectieOverspanningen/objectTree': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'aoInspectieOverspanningenControllers.getElements',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    icons: Type.Optional(
                                        Type.Array(
                                            Type.Object({
                                                iconName: Type.String(),
                                                severity: Type.String(),
                                                titleKey: Type.Optional(Type.String()),
                                                color: Type.Optional(Type.String()),
                                                backgroundColor: Type.Optional(Type.String()),
                                            }),
                                        ),
                                    ),
                                    units: Type.Array(
                                        Type.Object({
                                            icons: Type.Optional(
                                                Type.Array(
                                                    Type.Object({
                                                        iconName: Type.String(),
                                                        severity: Type.String(),
                                                        titleKey: Type.Optional(Type.String()),
                                                        color: Type.Optional(Type.String()),
                                                        backgroundColor: Type.Optional(Type.String()),
                                                    }),
                                                ),
                                            ),
                                            manifestations: Type.Array(
                                                Type.Object({
                                                    icons: Type.Optional(
                                                        Type.Array(
                                                            Type.Object({
                                                                iconName: Type.String(),
                                                                severity: Type.String(),
                                                                titleKey: Type.Optional(Type.String()),
                                                                color: Type.Optional(Type.String()),
                                                                backgroundColor: Type.Optional(Type.String()),
                                                            }),
                                                        ),
                                                    ),
                                                    id: Type.String(),
                                                    inspectionStandardData: Type.Any(),
                                                    name: Type.String(),
                                                    code: Type.String(),
                                                    elementId: Type.String(),
                                                    unitId: Type.String(),
                                                }),
                                            ),
                                            id: Type.String(),
                                            inspectionStandardData: Type.Any(),
                                            name: Type.String(),
                                            code: Type.String(),
                                            isArchived: Type.Boolean(),
                                            elementId: Type.String(),
                                            material: Type.String(),
                                        }),
                                    ),
                                    id: Type.String(),
                                    inspectionStandardData: Type.Any(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    elementGroupName: Type.String(),
                                    isArchived: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
    '/api/surveys/{surveyId}/elements/amsterdamOverspanningen/inspectieOverspanningen/report': {
        parameters: [createPathGuidParameter('surveyId')],
        get: {
            operationId: 'aoInspectieOverspanningenControllers.getReportData',
            responses: {
                '200': {
                    description: 'Result of the operation',
                    content: {
                        'application/json': {
                            schema: Type.Array(
                                Type.Object({
                                    units: Type.Array(
                                        Type.Object({
                                            assets: Type.Array(
                                                Type.Pick(assetTableSchema, [
                                                    'description',
                                                    'id',
                                                    'type',
                                                    'unitId',
                                                    'filenameThumbnail',
                                                    'filenameMidSize',
                                                ]),
                                            ),
                                            surveyInspectionStandardData: Type.Object({
                                                nen3140Score: optionalScoreSchema,
                                                remarks: Type.Optional(Type.String()),
                                            }),
                                            manifestations: Type.Array(
                                                Type.Object({
                                                    assets: Type.Array(
                                                        Type.Pick(assetTableSchema, [
                                                            'description',
                                                            'id',
                                                            'type',
                                                            'manifestationId',
                                                            'filenameThumbnail',
                                                            'filenameMidSize',
                                                        ]),
                                                    ),
                                                    surveyInspectionStandardData: Type.Object({
                                                        nen3140Score: optionalScoreSchema,
                                                        remarks: Type.Optional(Type.String()),
                                                    }),
                                                    id: Type.String(),
                                                    inspectionStandardData: Type.Any(),
                                                    name: Type.String(),
                                                    code: Type.String(),
                                                    elementId: Type.String(),
                                                    unitId: Type.String(),
                                                }),
                                            ),
                                            id: Type.String(),
                                            inspectionStandardData: Type.Any(),
                                            name: Type.String(),
                                            code: Type.String(),
                                            isArchived: Type.Boolean(),
                                            elementId: Type.String(),
                                            material: Type.String(),
                                        }),
                                    ),
                                    id: Type.String(),
                                    inspectionStandardData: Type.Any(),
                                    name: Type.String(),
                                    code: Type.String(),
                                    elementGroupName: Type.String(),
                                    isArchived: Type.Boolean(),
                                }),
                            ),
                        },
                    },
                },
            },
        },
    },
} as const;
